<template>
  <div class="page_container">
    <div class="top_header" v-if="!headerHidden">
      <div class="logo"></div>
      <div class="logo_title" v-text="appName"></div>
      <div id="open_app"></div>
    </div>
    <div :class="{'main_content':true,'allHeight':headerHidden}">
      <router-view />
    </div>
  </div>
</template>
<script>

import { mapState, mapActions } from "vuex";
import { getRandomStr32,initOpenApplicationFun } from "@/utils";

export default {
  name: "Layout",
  data() {
    return {
      headerHidden: false, // 是否隐藏顶部
    };
  },
  watch: {
    '$route'(to, from) {
      if (to.path == from.path) {
        location.reload();
      }
    }
  },
  computed: {
    ...mapState("app", ["deviceId", "appName"]),
  },
  methods: {
    ...mapActions("app", ["setDeviceId"]),

  },
  created() {
    let query = this.$route.query;

    if (Object.prototype.hasOwnProperty.call(query, "client")) {
      console.log('1111',JSON.stringify(query))
      if (query.client == 1 || query.client == '1' || query.client == true || query.client == 'true') {
        this.headerHidden = true;
      }
    }

    if (!this.deviceId) {
      var deviceId = getRandomStr32();
      this.setDeviceId(deviceId);
    }
    // 友盟打开app
    initOpenApplicationFun('open_app',query)

    console.log('this.headerHidden',this.headerHidden)
  },
};
</script>
<style lang="scss" scoped>
.page_container {
  width: 100%;
  height: 100%;
  .top_header {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    z-index: 9999;
    width: 100%;
    height: 12.4vw;
    background-color: #fff;
    outline: 1px solid #f0f0f0;
    .logo {
      float: left;
      width: 8.4vw;
      height: 8.4vw;
      background-image: url(~@/assets/images/logo/logo2.jpg);
      background-repeat: no-repeat;
      background-position: center center;
      background-size: contain;
      margin-left: 3.6vw;
      margin-top: 2vw;
    }
    .logo_title {
      float: left;
      height: 5vw;
      line-height: 5vw;
      margin-left: 1.8vw;
      margin-top: 3.7vw;
      font-size: 4vw;
    }
    #open_app {
      float: right;
      width: 15vw;
      height: 6.2vw;
      margin-right: 3vw;
      margin-top: 3.1vw;
      background-image: url(~@/assets/images/btn_open.png);
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
    }
  }
  .main_content {
    position: relative;
    left: 0;
    top: 12.4vw;
    width: 100%;
    height: calc(100% - 12.4vw);
  }
  .allHeight{
    height: calc(100%);
    top: 0;
  }
}
@media screen and (min-width: 750px) {
  .page_container {
    .top_header {
      height: 93px;
      .logo {
        width: 63px;
        height: 63px;
        margin-left: 27px;
        margin-top: 15px;
      }
      .logo_title {
        height: 37.5px;
        line-height: 37.5px;
        margin-left: 13.5px;
        margin-top: 27.75px;
        font-size: 28px;
      }
      #open_app {
        width: 112.5px;
        height: 46.5px;
        margin-right: 22.5px;
        margin-top: 23.25px;
      }
    }
    .main_content {
      top: 93px;
      height: calc(100% - 93px);
    }
  }
}
</style>